import { browserHistory } from 'react-router';
// For some reason  import { createMemoryHistory } from 'react-router' us not behaving;
import createMemoryHistory from 'react-router/lib/createMemoryHistory';

/**
 * In test/server env we don't have access to browser history API
 * so use 'memory' mock
 */

const historyType =
  process.env.NODE_ENV === 'test' || __SERVER__
    ? 'memoryHistory'
    : 'browserHistory';

const historyConfig = {};

const history =
  historyType === 'memoryHistory'
    ? createMemoryHistory(historyConfig)
    : browserHistory;

history.type = historyType;

export default history;
